(() => {
  if (globalThis.kloveProcessInstalled) return;
  globalThis.kloveProcessInstalled = true;
  const init = () => document.querySelectorAll('[data-klove-process]').forEach(section => {
    if (section.dataset.motionInitialized || !('IntersectionObserver' in window)) return;
    section.dataset.motionInitialized = 'true';
    const controller = new AbortController();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const cards = [...section.querySelectorAll('.kd-process-card')];
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (controller.signal.aborted || !entry.isIntersecting) return;
      if (entry.target.matches('.kd-process-card')) entry.target.classList.add('is-revealed');
      else section.classList.add('is-thread-visible');
      observer.unobserve(entry.target);
    }), {threshold:.15});
    const revealCards = () => cards.forEach(card => card.classList.add('is-revealed'));
    const reveal = () => {
      if (!reduced.matches) return;
      revealCards();
      section.classList.add('is-thread-visible');
      observer.disconnect();
    };
    if (reduced.matches) reveal();
    else {
      section.dataset.motionReady = 'true';
      cards.forEach(card => observer.observe(card));
      const thread = section.querySelector('.kd-process__thread');
      if (thread) observer.observe(thread);
    }
    reduced.addEventListener('change', reveal, {signal:controller.signal});
    section.addEventListener('focusin', revealCards, {signal:controller.signal});
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      controller.abort();
      delete section.dataset.motionInitialized;
      delete section.dataset.motionReady;
    }, {signal:controller.signal});
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();
